export const checkPasswordValid = (password: string) =>
  String(password).match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/);
